import { createSelector } from '../reselect';
import { total, getNewStatsService, simpleChart, simpleChart2, safeDivide } from '../generalUtils';

const getNewStats = getNewStatsService('snapchat-ads');

const totalSnapchatSpend = createSelector([getNewStats], (stats) => {
  return total(stats, 'spend');
});

const chartSnapchatAds = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'spend');
});

const snapchat_impressions = createSelector([getNewStats], (stats) => {
  return total(stats, 'impressions');
});

const snapchat_impressions_chart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'impressions');
});

const snapchat_swipes = createSelector([getNewStats], (stats) => {
  return total(stats, 'clicks');
});

const snapchat_swipes_chart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'clicks');
});

const totalSnapchatConversionPurchasesValue = createSelector([getNewStats], (stats) => {
  return total(stats, 'conversionValue');
});

const chartSnapchatConversionPurchasesValue = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'conversionValue');
});

const totalSnapchatConversionPurchases = createSelector([getNewStats], (stats) => {
  return total(stats, 'purchases');
});

const chartSnapchatConversionPurchases = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'purchases');
});

const totalSnapchatRoas = createSelector(
  [totalSnapchatConversionPurchasesValue, totalSnapchatSpend],
  (conversionValue, spend) => safeDivide(conversionValue, spend)
);

const snapchatCpm = createSelector(
  [snapchat_impressions, totalSnapchatSpend],
  (impressions, spend) => safeDivide(spend, impressions / 1000)
);

const snapchatCpc = createSelector([snapchat_swipes, totalSnapchatSpend], (clicks, spend) =>
  safeDivide(clicks, spend / 1000)
);

const snapchatCtr = createSelector(
  [snapchat_swipes, snapchat_impressions],
  (clicks, impressions) => safeDivide(clicks, impressions) * 100
);

const snapchatCpa = createSelector(
  [totalSnapchatConversionPurchases, totalSnapchatSpend],
  (purchases, spend) => safeDivide(spend, purchases)
);

const snapchatCpmChart = createSelector(
  [snapchat_impressions_chart, chartSnapchatAds],
  (impressions, spend) => {
    return simpleChart2(spend, impressions, { chart1yMultiplier: 1000 });
  }
);

const snapchatCpaChart = createSelector(
  [chartSnapchatConversionPurchasesValue, chartSnapchatAds],
  (purchases, spend) => simpleChart2(spend, purchases, { chart1yMultiplier: 1 })
);

const snapchatRoasChart = createSelector(
  [chartSnapchatConversionPurchasesValue, chartSnapchatAds],
  (conversionValue, spend) => simpleChart2(conversionValue, spend)
);

const PROPS_TO_SELECTORS = {};

export default {
  PROPS_TO_SELECTORS,
  SELECTORS: {
    totalSnapchatSpend,
    chartSnapchatAds,
    snapchat_impressions,
    snapchat_impressions_chart,
    snapchat_swipes,
    snapchat_swipes_chart,
    totalSnapchatConversionPurchasesValue,
    chartSnapchatConversionPurchasesValue,
    totalSnapchatConversionPurchases,
    chartSnapchatConversionPurchases,
    snapchatCpm,
    snapchatCpc,
    snapchatCtr,
    snapchatCpmChart,
    snapchatCpa,
    snapchatCpaChart,
    totalSnapchatRoas,
    snapchatRoasChart,
    snapchatImpressions: snapchat_impressions,
  },
};
